import React from 'react';
import PropTypes from 'prop-types';
import Card from '../../../../core/layout/Card';
import Separator from '../../../../core/layout/Separator';
import CertificationTestItemHistoryBreadcrumbs from './CertificationTestItemHistoryBreadcrumbs';
import CertificationTestItemHistoryDetail from './CertificationTestItemHistoryDetail';
import ItemHistoryListContainer from '../ItemHistoryListContainer';

const CertificationTestItemHistoryScene = (props) => (
  <div>
    <CertificationTestItemHistoryBreadcrumbs
      certificationTestItem={props.certificationTestItem}
      fetching={props.fetching}
    />
    <Separator />
    <CertificationTestItemHistoryDetail certificationTestItem={props.certificationTestItem} fetching={props.fetching} />
    <Card title="History" loading={props.fetching}>
      <ItemHistoryListContainer itemId={props.certificationTestItem.item.id} />
    </Card>
  </div>
);

CertificationTestItemHistoryScene.propTypes = {
  certificationTestItem: PropTypes.shape({
    certificationTestCourseAbility: PropTypes.shape({
      id: PropTypes.string.isRequired,
      ability: PropTypes.string.isRequired,
      course: PropTypes.shape({
        name: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    item: PropTypes.shape({
      id: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      grammar: PropTypes.shape({
        name: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
  fetching: PropTypes.bool,
};

CertificationTestItemHistoryScene.defaultProps = {
  fetching: false,
};

export default CertificationTestItemHistoryScene;
